import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getLGPD(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("lGPD/access/obter", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLinkLGPD(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("lGPD/access/gerarLink", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLgpdPorData(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("lGPD/access/listarLgpdPorData", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};